import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import './LanguageToggle.css';

export const LanguageToggle: React.FC<{ className?: string }> = ({ className = '' }) => {
  const { language, setLanguage } = useLanguage();

  return (
    <div className={`language-switcher-group ${className}`} role="group" aria-label="Language selector">
      <button
        type="button"
        className={`lang-btn ${language === 'de' ? 'active' : ''}`}
        onClick={() => setLanguage('de')}
        aria-pressed={language === 'de'}
        aria-label="Deutsch"
      >
        <span className="lang-flag">🇩🇪</span> DE
      </button>
      <button
        type="button"
        className={`lang-btn ${language === 'en' ? 'active' : ''}`}
        onClick={() => setLanguage('en')}
        aria-pressed={language === 'en'}
        aria-label="English"
      >
        <span className="lang-flag">🇬🇧</span> EN
      </button>
    </div>
  );
};

export default LanguageToggle;
